export default "__VITE_ASSET__DMGNS5_5__"